import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProprietariosDocumentosUploadPage } from './proprietarios-documentos-upload.page';

const routes: Routes = [{ path: '', component: ProprietariosDocumentosUploadPage }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProprietariosDocumentosUploadRoutingModule { }
